import React, { useState } from 'react';

const data = [
  {
    title: 'Reconciliation of Share Capital as on Sep 25',
    fileUrl: 'https://assets.bharatrohan.in/ReconciliationShareCapital/Reg_76_Sep25.html',
  },
  {
    title: 'Reconciliation of Share Capital as on Dec 25',
    fileUrl: 'https://assets.bharatrohan.in/ReconciliationShareCapital/Reconciliation_of_Share_Capital_as_on_Dec_25.html',
  },
  {
    title: 'Reconciliation of Share Capital as on Mar 26',
    fileUrl: 'https://assets.bharatrohan.in/ReconciliationShareCapital/Reco_of_Share_Capital_Mar26.html',
  },
  {
    title: 'Reconciliation of Share Capital as on June 26',
    fileUrl: 'https://assets.bharatrohan.in/ReconciliationShareCapital/Reco-June26.html',
  },
  {
    title: 'Reconciliation of Share Capital as on September 26',
    fileUrl: 'https://assets.bharatrohan.in/ReconciliationShareCapital/Reconciliation_of_Share_Capital_as_on_Sep_26.pdf',
  }
];

export default function Share01() {
    const [selected, setSelected] = useState<number>(0)
    const isMobile = window.innerWidth<1024;
    
    return (
        <div className="py-8 lg:pb-10"> {/* Replaceable line is down */}
      {/* <div className="py-8 bg-cream lg:pb-10"></div> */}
      {/* <div className="w-container-lg"> */}
        <div className="flex flex-col lg:flex-row items-start gap-x-12 xl:gap-x-16 2xl:gap-x-20 gap-y-6 md:gap-y-12">
          <div className="grid  w-full blade-top-padding-sm lg:pt-0 lg:w-[100%] gap-y-4 lg:gap-y-6 flex-col">
            {data.map((item, index) => (
              <div className='flex justify-around sm:flex'>
                <div className="md:w-[70%] sm:w-2" key={index}>
                  <div
                    onClick={() => {
                      setSelected(index)
                    }}
                    className={`flex w-full py-4 border px-4 sm:px-6 md:px-8 lg:px-4 xl:px-6 border-green items-center justify-between cursor-pointer transition-al duration-1000 ${
                      selected === index
                        ? 'bg-transparent cursor-auto pt-6'
                        : 'bg-transparent'
                    }`}
                  >
                    <a href={item.fileUrl} target='_blank' className="grid w-full grid-cols-[2.5rem_1fr_auto] sm:grid-cols-[3rem_1fr_auto] xl:grid-cols-[4rem_1fr_auto]">
                    <span
                      className={`text-lg lg:text-xl 2xl:text-xl opacity-25 font-bold transition-all duration-1000 ${
                        selected === index ? 'text-black' : 'text-black'
                      }`}
                    >{index >= 9 ? `${index + 1}` : `0${index + 1}`}</span>
                      <h4
                        className={`${
                          selected === index ? 'text-green' : 'text-green'
                        } font-semibold text-left transition-all duration-1000 self-center 2xl:text-xl overflow-hidden`}
                      >
                        <div
                          className={`inline-block whitespace-nowrap ${(isMobile && item.title.length > 25)? 'animate-slide 2xl:animate-none px-2' : item.title.length>40?'animate-slide':'w-80'}`} 
                          // style={{ paddingLeft: item.title.length > 10 ? '100%' : 0 }} 
                          >

                          {item.title}
                          </div>
                      </h4>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      {/* </div> */}
    </div>
    )
} 